import * as SystemOfUnits from '@/lib/system-of-units'
import * as SystemOfUnitsConstants from '@/lib/system-of-units-constants'
import * as Constants from '@/lib/constants'
import GnssStatus from '@/lib/gnss-status'
import i18n from '@/lib/i18n'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/axisPointer'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import Vue from 'vue'

const convertUnits = require('convert-units')

// echarts
// https://echarts.apache.org/en/option.html

export default {
  data() {
    // 高度
    let altMax = this.$store.getters.currentTaskMaxAltitude
    let altMin = this.$store.getters.currentTaskMinAltitude
    let currentTaskAltitudes = this.$store.getters.currentTaskAltitudes

    let altTargetUnit = ''
    if (SystemOfUnits.isMetric()) {
      altTargetUnit = ' m'
    } else {
      altTargetUnit = ' ft'
      altMax = convertUnits(altMax)
        .from('m')
        .to('ft')
      altMin = convertUnits(altMin)
        .from('m')
        .to('ft')

      let wkTaskAltitudes = []
      currentTaskAltitudes.forEach(function(taskAltitude) {
        wkTaskAltitudes.push(
          convertUnits(taskAltitude)
            .from('m')
            .to('ft')
        )
      })
      currentTaskAltitudes = wkTaskAltitudes
    }
    const altRange = (altMax - altMin) * 0.1
    const altTitle = i18n.tt('customHeight')
    const altXDatas = Object.entries(currentTaskAltitudes).map(array => array[0])
    const altYDatas = Object.entries(currentTaskAltitudes).map(array => array[1])

    // スピード
    let speedMax = this.$store.getters.currentTaskMaxSpeed
    let speedMin = this.$store.getters.currentTaskMinSpeed
    let currentTaskSpeeds = this.$store.getters.currentTaskSpeeds
    let speedTargetUnit = ''
    let wkTaskSpeeds = []

    if (SystemOfUnits.isMetric()) {
      speedTargetUnit = ' km/h'
      speedMax = convertUnits(speedMax)
        .from(SystemOfUnitsConstants.MeterPerSecond)
        .to(SystemOfUnitsConstants.KilloMeterPerHour)
      speedMin = convertUnits(speedMin)
        .from(SystemOfUnitsConstants.MeterPerSecond)
        .to(SystemOfUnitsConstants.KilloMeterPerHour)

      currentTaskSpeeds.forEach(function(taskSpeed) {
        wkTaskSpeeds.push(
          convertUnits(taskSpeed)
            .from(SystemOfUnitsConstants.MeterPerSecond)
            .to(SystemOfUnitsConstants.KilloMeterPerHour)
        )
      })
      currentTaskSpeeds = wkTaskSpeeds
    } else {
      speedTargetUnit = ' mph'
      speedMax = convertUnits(speedMax)
        .from('km')
        .to('mi')
      speedMin = convertUnits(speedMin)
        .from('km')
        .to('mi')

      currentTaskSpeeds.forEach(function(taskSpeed) {
        wkTaskSpeeds.push(
          convertUnits(taskSpeed)
            .from('km')
            .to('mi')
        )
      })
      currentTaskSpeeds = wkTaskSpeeds
    }

    const speedRange = (speedMax - speedMin) * 0.01
    const speedTitle = i18n.tt('customSpeed')
    const speedXDatas = Object.entries(currentTaskSpeeds).map(array => array[0])
    const speedYDatas = Object.entries(currentTaskSpeeds).map(array => array[1])

    // 傾斜度 slant
    let slants = this.$store.getters.currentTaskSlants
    const slantTitle = i18n.tt('customGradient')
    const slantXDatas = Object.entries(slants).map(array => array[0])
    const slantYDatas = Object.entries(slants).map(array => array[1])

    // 左右ずれ
    let guidanceErrors = this.$store.getters.currentTaskGuidanceErrors
    const guidanceErrorsTitle = i18n.tt('customLeftRightMisalignment')
    const guidanceErrorsXDatas = Object.entries(guidanceErrors).map(array => array[0])
    const guidanceErrorsYDatas = Object.entries(guidanceErrors).map(array => array[1])

    // 方位ずれ
    let guidanceHeadingErrors = this.$store.getters.currentTaskGuidanceHeadingErrors
    const guidanceHeadingErrorsTitle = i18n.tt('customAzimuthShift')
    const guidanceHeadingErrorsXDatas = Object.entries(guidanceHeadingErrors).map(array => array[0])
    const guidanceHeadingErrorsYDatas = Object.entries(guidanceHeadingErrors).map(array => array[1])

    // GNSS状態
    let gnssStatus = this.$store.getters.currentTaskGnssStatus
    const gnssStatusTitle = i18n.tt('customGnssStatus')
    const gnssStatusXDatas = Object.entries(gnssStatus).map(array => array[0])
    const gnssStatusYDatasWork = Object.entries(gnssStatus).map(array => array[1])
    let gnssStatusYDatas = []
    // 表示用のsort順に変換を行う
    for (let i = 0; i < gnssStatusYDatasWork.length; i++) {
      const sort = GnssStatus.getSortFromInteger(gnssStatusYDatasWork[i])
      gnssStatusYDatas.push(sort)
    }

    // 測位衛星数
    let gnssNumOfSatellites = this.$store.getters.currentTaskGnssNumOfSatellites
    const gnssNumOfSatellitesTitle = i18n.tt('customNumOfSatellites')
    const gnssNumOfSatellitesXDatas = Object.entries(gnssNumOfSatellites).map(array => array[0])
    const gnssNumOfSatellitesYDatas = Object.entries(gnssNumOfSatellites).map(array => array[1])

    const eventBus = new Vue()

    const colorIndex = 4

    return {
      eventBus,
      composedChartOptions: {
        toolbox: {
          show: true,
        },
        grid: [
          { containLabel: true, left: 0, right: 0, bottom: 32 }, // 高度
          { containLabel: true, left: 0, right: 0, bottom: 32 }, // スピード
          { containLabel: true, left: 0, right: 0, bottom: 32 }, // 測位衛星数
          { containLabel: true, left: 0, right: 0, bottom: 32 }, // GNSS状態
          { containLabel: true, left: 0, right: 0, bottom: 32 }, // 左右ずれ
          { containLabel: true, left: 0, right: 0, bottom: 32 }, // 方位ずれ
          { containLabel: true, left: 0, right: 0, bottom: 32 }, // 傾斜度
        ],
        // 区間選択 (F5-3): スライダーで選んだ範囲を派生記録として保存できる
        dataZoom: [
          {
            type: 'slider',
            xAxisIndex: [0, 1, 2, 3, 4, 5, 6],
            start: 0,
            end: 100,
            bottom: 0,
            height: 22,
          },
        ],
        tooltip: {
          trigger: 'axis',

          formatter: function(params) {
            const dataIndex = params[0].dataIndex
            eventBus.$emit(Constants.EVENT_SET_MAP_MARKER, dataIndex)
            let returnText = ''
            for (let index = 0; index < params.length; index++) {
              const seriesName = params[index].seriesName
              if (seriesName === altTitle) {
                returnText += altTitle + ':' + params[index].value + altTargetUnit + '<br>'
              } else if (seriesName === speedTitle) {
                returnText += speedTitle + ':' + params[index].value + speedTargetUnit + '<br>'
              } else if (seriesName === gnssNumOfSatellitesTitle) {
                returnText += gnssNumOfSatellitesTitle + ':' + params[index].value + '<br>'
              } else if (seriesName === gnssStatusTitle) {
                returnText += gnssStatusTitle + ':'
                returnText += GnssStatus.getTextFromSort(params[index].value)
                returnText += '(' + params[index].value + ')' + '<br>'
              } else if (seriesName === guidanceErrorsTitle) {
                returnText += guidanceErrorsTitle + ':' + params[index].value + ' m <br>'
              } else if (seriesName === guidanceHeadingErrorsTitle) {
                returnText += guidanceHeadingErrorsTitle + ':' + params[index].value + ' deg <br>'
              } else if (seriesName === slantTitle) {
                returnText += slantTitle + ':' + params[index].value + ' deg <br>'
              }
            }

            return returnText
          },
        },

        axisPointer: {
          link: { xAxisIndex: 'all' },
        },
        legend: {
          left: 0,
          data: [
            altTitle,
            speedTitle,
            gnssNumOfSatellitesTitle,
            gnssStatusTitle,
            guidanceErrorsTitle,
            guidanceHeadingErrorsTitle,
            slantTitle,
          ],
        },
        color: [
          Constants.TRACK_COLORS_ALTITUDE[colorIndex],
          Constants.TRACK_COLORS_SPEED[colorIndex],
          Constants.TRACK_COLORS_GNSS_NUM_OF_SATELITES[colorIndex],
          Constants.TRACK_COLORS_GNSS_STATUS[colorIndex],
          Constants.TRACK_COLORS_GUIDANCE_ERROR[colorIndex],
          Constants.TRACK_COLORS_GUIDANCE_HEADING_ERROR[colorIndex],
          Constants.TRACK_COLORS_SLANT[colorIndex],
        ],
        xAxis: [
          {
            show: false,
            type: 'category',
            boundaryGap: false,
            data: altXDatas,
            axisLine: { onZero: true },
            axisPointer: { label: { show: false } },
          },
          {
            type: 'category',
            data: speedXDatas,
            boundaryGap: false,
            show: false,
            axisLine: { onZero: true },
            axisPointer: { label: { show: false } },
            gridIndex: 1,
          },
          {
            type: 'category',
            data: gnssNumOfSatellitesXDatas,
            boundaryGap: false,
            show: false,
            axisLine: { onZero: true },
            axisPointer: { label: { show: false } },
            gridIndex: 2,
          },
          {
            type: 'category',
            data: gnssStatusXDatas,
            boundaryGap: false,
            show: false,
            axisLine: { onZero: true },
            axisPointer: { label: { show: false } },
            gridIndex: 3,
          },
          {
            type: 'category',
            data: guidanceErrorsXDatas,
            boundaryGap: false,
            show: false,
            axisLine: { onZero: true },
            axisPointer: { label: { show: false } },
            gridIndex: 4,
          },
          {
            type: 'category',
            data: guidanceHeadingErrorsXDatas,
            boundaryGap: false,
            show: false,
            axisLine: { onZero: true },
            axisPointer: { label: { show: false } },
            gridIndex: 5,
          },
          {
            type: 'category',
            data: slantXDatas,
            boundaryGap: false,
            show: false,
            axisLine: { onZero: true },
            axisPointer: { label: { show: false } },
            gridIndex: 6,
          },
        ],
        yAxis: [
          { type: 'value', axisLabel: '', scale: true, show: false },
          {
            type: 'value',
            axisLabel: '',
            scale: true,
            gridIndex: 1,
            show: false,
          },
          {
            type: 'value',
            axisLabel: '',
            scale: true,
            gridIndex: 2,
            show: false,
          },
          {
            type: 'value',
            axisLabel: '',
            scale: true,
            gridIndex: 3,
            show: false,
          },
          {
            type: 'value',
            axisLabel: '',
            scale: true,
            gridIndex: 4,
            show: false,
          },
          {
            type: 'value',
            axisLabel: '',
            scale: true,
            gridIndex: 5,
            show: false,
          },
          {
            type: 'value',
            axisLabel: '',
            scale: true,
            gridIndex: 6,
            show: false,
          },
        ],
        series: [
          {
            name: altTitle,
            type: 'line',
            smooth: true,
            data: altYDatas,
          },
          {
            name: speedTitle,
            type: 'line',
            smooth: true,
            data: speedYDatas,

            xAxisIndex: 1,
            yAxisIndex: 1,
          },
          {
            name: gnssNumOfSatellitesTitle,
            type: 'line',
            smooth: true,
            data: gnssNumOfSatellitesYDatas,
            xAxisIndex: 2,
            yAxisIndex: 2,
          },
          {
            name: gnssStatusTitle,
            type: 'line',
            smooth: true,
            data: gnssStatusYDatas,
            xAxisIndex: 3,
            yAxisIndex: 3,
          },
          {
            name: guidanceErrorsTitle,
            type: 'line',
            smooth: true,
            data: guidanceErrorsYDatas,
            xAxisIndex: 4,
            yAxisIndex: 4,
          },
          {
            name: guidanceHeadingErrorsTitle,
            type: 'line',
            smooth: true,
            data: guidanceHeadingErrorsYDatas,
            xAxisIndex: 5,
            yAxisIndex: 5,
          },
          {
            name: slantTitle,
            type: 'line',
            smooth: true,
            data: slantYDatas,
            xAxisIndex: 6,
            yAxisIndex: 6,
          },
        ],
      },
    }
  },
}
